"use client";

import { ArrowRight, Sparkles, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function What4everFreshMeans() {
  const {
    ref: badgeRef,
    isVisible: badgeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const stats = [{
    value: "100%",
    label: "Mission Focused"
  }, {
    value: "24/7",
    label: "Awareness Driven"
  }, {
    value: "Global",
    label: "Community Impact"
  }];
  return <section data-section-id="152" id="what-4ever-fresh-means" className="relative overflow-hidden bg-background py-24 sm:py-32 lg:py-40 bg-background text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08]" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "64px 64px",
      maskImage: "radial-gradient(ellipse 80% 60% at 50% 40%, black 40%, transparent 80%)",
      WebkitMaskImage: "radial-gradient(ellipse 80% 60% at 50% 40%, black 40%, transparent 80%)"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute -top-32 left-1/4 h-[480px] w-[480px] rounded-lg opacity-30 blur-3xl" style={{
      background: "radial-gradient(circle, var(--chart-1) 0%, transparent 70%)"
    }} aria-hidden="true" />
      <div className="pointer-events-none absolute top-1/3 right-1/4 h-[420px] w-[420px] rounded-lg opacity-25 blur-3xl" style={{
      background: "radial-gradient(circle, var(--chart-2) 0%, transparent 70%)"
    }} aria-hidden="true" />
      <div className="pointer-events-none absolute -bottom-24 left-1/3 h-[400px] w-[400px] rounded-lg opacity-20 blur-3xl" style={{
      background: "radial-gradient(circle, var(--chart-3) 0%, transparent 70%)"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
          {}
          <div ref={badgeRef} className={`transition-all duration-700 ease-out ${badgeVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
            <Badge variant="outline" className="mb-8 gap-2 border-border/60 bg-card/60 px-4 py-1.5 text-xs font-medium text-foreground backdrop-blur-sm rounded-lg">
              <Sparkles className="size-3.5 text-[var(--chart-1)]" />
              <span>Keeping Awareness Issues Forever Fresh</span>
              <span className="ml-1 text-muted-foreground">Est. 2024</span>
            </Badge>
          </div>

          {}
          <h1 ref={headingRef} className={`font-default text-5xl font-bold leading-[1.05] tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-8xl transition-all duration-700 ease-out ${headingVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
            Keeping issues{" "}
            <span className="bg-clip-text text-transparent" style={{
            backgroundImage: "linear-gradient(135deg, var(--chart-1) 0%, var(--chart-2) 50%, var(--chart-3) 100%)"
          }}>
              forever fresh
            </span>
          </h1>

          {}
          <p ref={subRef} className={`mt-8 max-w-2xl text-lg leading-relaxed text-muted-foreground sm:text-xl transition-all duration-700 delay-100 ease-out ${subVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
            Forever Fresh is a mission-driven platform dedicated to keeping humanitarian awareness issues at the forefront of public consciousness. We combine advocacy with purpose-based apparel to support causes that matter.
          </p>

          {}
          <div ref={ctaRef} className={`mt-10 flex flex-col items-center gap-4 sm:flex-row transition-all duration-700 delay-200 ease-out ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
            <Link to="/CurrentCausesPage">
              <Button size="lg" className="group h-12 gap-2 rounded-lg px-7 text-base font-medium shadow-lg bg-primary text-primary-foreground">
                <Zap className="size-4" />
                Explore Causes
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
              </Button>
            </Link>
            <Link to="/ShopPage">
              <Button size="lg" variant="outline" className="h-12 gap-2 rounded-lg border-border/60 bg-card/40 px-7 text-base font-medium text-foreground backdrop-blur-sm hover:bg-accent">
                Shop Current Drop
              </Button>
            </Link>
          </div>

          {}
          <div ref={statsRef} className={`mt-20 grid w-full max-w-2xl grid-cols-1 gap-8 sm:grid-cols-3 transition-all duration-700 delay-300 ease-out ${statsVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
            {stats.map((stat, i) => <div key={stat.label} data-index={i} className="flex flex-col items-center gap-1.5 border-l border-border/40 px-4 first:border-l-0 sm:border-l">
                <div className="font-default text-3xl font-bold tracking-tight bg-clip-text text-transparent" style={{
              backgroundImage: "linear-gradient(135deg, var(--chart-1) 0%, var(--chart-2) 100%)"
            }}>
                  {stat.value}
                </div>
                <div className="text-sm text-muted-foreground">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}